// Auto-generated from Contentful - DO NOT EDIT
// Generated at: 2026-02-04T02:14:54.504Z

const videoTourPolicy = {
  pageName: `HR Policy`,
  tourTitle: `Track the Progress of Your Policies Here`,
  videoUrl: `https://www.loom.com/embed/397a117012c14c19b7f110015ff7aca0`,
  description: `This is where you can track the progress of the HR policies that you have requested. View, provide feedback to your HR Manager, and approve your policies all in one place before sending it out to your employees.`,
  buttonLabel: `Got It, Thanks!`,
} as const;

export default videoTourPolicy;
